// aiPrompts.js

/** Варианты списком: «A) ...», «B) ...». Отдельной функцией — шаблон в шаблоне не читается. */
const letteredAnswers = (answers) =>
    answers.map((answer, index) => `${String.fromCodePoint(65 + index)}) ${answer}`).join('\n');

const AI_PROMPTS = {
    analyze: {
        en: ({ question, answers }) => {
            const formattedAnswers = answers.map((a, idx) => `${idx + 1}) ${a}`).join('\n');
            return `Analyze and respond strictly in the format:
🎯 What is being asked?
Briefly describe the goal of the question.
💡 Key knowledge:
What AWS knowledge is essential to solve this?
🔍 Option breakdown:
For each option:
\t• ✅ if correct
\t• ❌ if incorrect
\t• 🟡 if partially correct or misleading
After each — explain why.
🔑 Memory tip:
Give a trick or rule to help remember the right approach.

Question:
${question}

Options:
${formattedAnswers}`;
        },

        ru: ({ question, answers }) => {
            const formattedAnswers = answers.map((a, idx) => `${idx + 1}) ${a}`).join('\n');
            return `Проанализируй и ответь строго в формате:
🎯 Что требуется?
Кратко опиши, что именно спрашивается, какова цель задачи.
💡 Ключевые знания:
Что нужно знать из AWS, чтобы решить этот вопрос. Только то, что необходимо для понимания.
🔍 Разбор вариантов:
Для каждого варианта поставь в начале:
\t• ✅ если он правильный
\t• ❌ если он неправильный
\t• 🟡 если он частично правильный или может сбить с толку
После каждого варианта — краткое объяснение, почему он подходит или нет.
🔑 Как запомнить?
Дай логическую подсказку или правило, которое поможет вспомнить правильный подход в будущем.

Вот вопрос:
${question}

Варианты:
${formattedAnswers}`;
        },
    },

    shortAnswer: {
        en: ({ question, answers }) => {
            return `Give only the correct answer letter(s), nothing else.

Question:
${question}

Options:
${letteredAnswers(answers)}`;
        },

        ru: ({ question, answers }) => {
            return `Дай только правильные буквы ответа, без пояснений.

Вопрос:
${question}

Варианты:
${letteredAnswers(answers)}`;
        },
    }
};

/**
 * Получить шаблон по типу и языку
 * @param {'analyze'|'shortAnswer'} type
 * @param {'en'|'ru'} lang
 * @param {{ question: string, answers: string[] }} data
 * @returns {string}
 */
export const getAIPrompt = (type, lang, data) => {
    const promptFn = AI_PROMPTS?.[type]?.[lang];
    if (!promptFn) {
        throw new Error(`No prompt template for type "${type}" and lang "${lang}"`);
    }
    return promptFn(data);
};
